import { render, staticRenderFns } from "./editorReviewSideBar.vue?vue&type=template&id=12544be9&scoped=true&"
import script from "./editorReviewSideBar.vue?vue&type=script&lang=js&"
export * from "./editorReviewSideBar.vue?vue&type=script&lang=js&"
import style0 from "./editorReviewSideBar.vue?vue&type=style&index=0&id=12544be9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12544be9",
  null
  
)

export default component.exports